import styles from "../../../styles/Participant-Employment.module.css"
import { RadioButton } from "primereact/radiobutton"

const RadioButtonField = ({
  label,
  value,
  setValue,
  short,
  long,
  valueName,
  disabled,
  callback,
}) => {
  return (
    <div className={styles.field}>
      <label className={styles.label} style={{ marginBottom: "5px" }}>
        {label}
      </label>
      <div className={styles.radio_btn_wrapper}>
        <div className={styles.radio_btn}>
          <RadioButton
            inputId={`Yes_${label}`}
            value={"Yes"}
            style={{ margin: "0" }}
            onChange={(e) => {
              valueName ? setValue(valueName, e.value) : setValue(e.value)
              if (callback) {
                callback(e.value)
              }
            }}
            disabled={disabled}
            checked={value === "Yes"}
          />
          <label htmlFor={`Yes_${label}`} className={styles.inline_label}>
            Yes
          </label>
        </div>
        <div className={styles.radio_btn}>
          <RadioButton
            inputId={`No_${label}`}
            value={"No"}
            style={{ margin: "0" }}
            onChange={(e) => {
              valueName ? setValue(valueName, e.value) : setValue(e.value)
              if (callback) {
                callback(e.value)
              }
            }}
            disabled={disabled}
            checked={value === "No"}
          />
          <label htmlFor={`No_${label}`} className={styles.inline_label}>
            No
          </label>
        </div>
        {!short && (
          <div className={styles.radio_btn}>
            <RadioButton
              inputId={`Unknown_${label}`}
              value={"Unknown"}
              style={{ margin: "0" }}
              onChange={(e) => {
                valueName ? setValue(valueName, e.value) : setValue(e.value)
                if (callback) {
                  callback(e.value)
                }
              }}
              disabled={disabled}
              checked={value === "Unknown"}
            />
            <label htmlFor={`Unknown_${label}`} className={styles.inline_label}>
              Unknown
            </label>
          </div>
        )}
        {long && (
          <div className={styles.radio_btn}>
            <RadioButton
              inputId={`Prefer not to answer_${label}`}
              value={"Prefer not to answer"}
              style={{ margin: "0" }}
              onChange={(e) => {
                valueName ? setValue(valueName, e.value) : setValue(e.value)
                if (callback) {
                  callback(e.value)
                }
              }}
              disabled={disabled}
              checked={value === "Prefer not to answer"}
            />
            <label
              htmlFor={`Prefer not to answer_${label}`}
              className={styles.inline_label}
            >
              Prefer not to answer
            </label>
          </div>
        )}
      </div>
    </div>
  )
}
export default RadioButtonField
